import axios from 'axios';
import { Role, CreateRoleForm, UpdateRoleForm, ApiResponse } from '../types';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.hostname}:5269/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const roleService = {
  // Get all roles
  getRoles: async (): Promise<ApiResponse<Role[]>> => {
    const response = await api.get('/roles');
    return response.data;
  },

  // Get role by ID
  getRole: async (id: number): Promise<ApiResponse<Role>> => {
    const response = await api.get(`/roles/${id}`);
    return response.data;
  },

  // Create role
  createRole: async (data: CreateRoleForm): Promise<ApiResponse<Role>> => {
    const response = await api.post('/roles', data);
    return response.data;
  },

  // Update role
  updateRole: async (id: number, data: UpdateRoleForm): Promise<ApiResponse<Role>> => {
    const response = await api.put(`/roles/${id}`, data);
    return response.data;
  },

  // Delete role
  deleteRole: async (id: number): Promise<ApiResponse<null>> => {
    const response = await api.delete(`/roles/${id}`);
    return response.data;
  },
};
